import _toConsumableArray from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import auth from '@/utils/auth';
import TabBar from '@/base/TabBar';
// import SkinChange from '@/components/SkinChange/index'
// import NewbieGuide from '@/components/NewbieGuide'
import { BRAND_TAB_BAR, MAIN_TAB_BAR } from '@/base/constant';
import { Dialog } from 'vant';
var THEME_COLORS = ['light', 'dark'];
export default {
  name: 'App',
  components: {
    TabBar: TabBar
    // SkinChange,
    // NewbieGuide
  },
  data: function data() {
    return {
      showGuide: false,
      hasMain: false,
      active: 0,
      tabBars: _toConsumableArray(MAIN_TAB_BAR),
      vueAppEnv: process.env.VUE_APP_ENV,
      interval: 0
    };
  },
  computed: {
    hasWeiChat: function hasWeiChat() {
      return this.$Utils.isBrowser().isWechat;
    }
  },
  watch: {
    $route: function $route() {
      this.handleSetRoute();
      if (window._czc) {
        var location = window.location;
        var contentUrl = location.pathname + location.hash;
        var refererUrl = '/';
        window._czc.push(['_trackPageview', contentUrl, refererUrl]);
      }
    }
  },
  beforeUpdate: function beforeUpdate() {
    this.handleBrandTab();
  },
  created: function created() {
    var _this = this;
    this.$GetActivity(null).then(function (res) {
      var list = res.data;
      if (list) {
        // 黑白色
        _this.grayscale = list.some(function (x) {
          return x.type === 'BLACK_WHITE_SKIN' && x.hasOpen;
        });
        _this.handleSetGrayTheme();
        _this.$store.commit('app/SET_ACTIVITIES_INFO', list);
        _this.$Utils.setSessionStorageKey('activitiesInfo', list);
      }
    });
  },
  mounted: function mounted() {
    this.handleTimeOutUpdate();
    this.handleBrandTab();
    this.handleSetRoute();
    this.handleSetTheme('Light');
    // 微信浏览器有许多兼容问题
    if (this.hasWeiChat && window.location.host.includes('h5')) {
      this.showGuide = true;
      var body = document.getElementsByTagName('body');
      // 禁止滚动
      if (body !== null && body !== void 0 && body.length) {
        body[0].style.overflow = 'hidden';
      }
    }
  },
  updated: function updated() {
    this.initApp();
    // 路由上有主题配置更新
    var _this$$route$query$th = this.$route.query.theme,
      theme = _this$$route$query$th === void 0 ? '' : _this$$route$query$th;
    if (theme && THEME_COLORS.includes(theme)) {
      var color = theme.toLowerCase().replace(theme[0], theme[0].toUpperCase());
      this.handleSetTheme(color);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.interval && clearInterval(this.interval);
  },
  methods: {
    // 自动刷新
    handleTimeOutUpdate: function handleTimeOutUpdate() {
      var versionMeta = window.document.querySelector('meta[name="version"]');
      var updateLoading = false;
      var dialogShow = false;
      var checkForUpdates = function checkForUpdates() {
        updateLoading = true;
        fetch("".concat(window.location.origin, "?time=").concat(Date.now())) // 前端服务器上存储版本号的文件
        .then(function (response) {
          return response.text();
        }).then(function (textHtml) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(textHtml, 'text/html');
          var metaVersion = doc.querySelector('meta[name="version"]');
          if ((metaVersion === null || metaVersion === void 0 ? void 0 : metaVersion.content) !== (versionMeta === null || versionMeta === void 0 ? void 0 : versionMeta.content)) {
            dialogShow = true;
            Dialog.confirm({
              title: '温馨提示',
              message: '检测到当前系统版本已更新，请刷新界面后使用。',
              confirmButtonText: '刷新'
            }).then(function () {
              window.location.reload();
            }).finally(function () {
              dialogShow = false;
            });
          }
        }).finally(function () {
          updateLoading = false;
        });
      };
      window.document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible' && !updateLoading && !dialogShow) {
          checkForUpdates();
        }
      });
      // 10分钟检查一次
      this.interval = setInterval(checkForUpdates, 600000);
    },
    // 哀悼色设置
    handleSetGrayTheme: function handleSetGrayTheme() {
      window.document.querySelector('html').style.filter = this.grayscale && window.location.pathname.includes('/home') ? 'grayscale(1)' : '';
    },
    // 设置主题色
    handleSetTheme: function handleSetTheme(color) {
      this.$store.commit('app/SET_THEME_COLOR', color);
      document.body.setAttribute('data-theme', color);
    },
    // 显示并高亮选中的tab bar
    handleSetRoute: function handleSetRoute() {
      var _this2 = this;
      this.$nextTick(function () {
        var path = _this2.$route.path;
        _this2.hasMain = _this2.tabBars.some(function (x) {
          return x.to.path === path || _this2.$route.name === x.to.name;
        });
        _this2.active = _this2.tabBars.findIndex(function (x) {
          return x.to.path === path;
        });
        _this2.handleSetGrayTheme();
      });
    },
    // 切换主题色
    handleChangeTheme: function handleChangeTheme() {
      var color = (auth.getThemeColor() || 'Dark') === 'Dark' ? 'Light' : 'Dark';
      this.handleSetTheme(color);
    },
    // 品牌馆底部tab bar不同
    handleBrandTab: function handleBrandTab() {
      var _this$$route$query = this.$route.query,
        originFrom = _this$$route$query.originFrom,
        storeNo = _this$$route$query.storeNo;
      this.isOriginFromBrand = originFrom === 'brand' && !!storeNo;
      this.tabBars = this.isOriginFromBrand ? BRAND_TAB_BAR : MAIN_TAB_BAR;
    },
    // app内初始化
    initApp: function initApp() {
      // h5沉浸式时取消iphone底部安全适配
      if (this.$Utils.appInfo && this.$route.query.hideNavBar === '1') {
        var body = document.getElementsByTagName('body');
        if (body !== null && body !== void 0 && body.length) {
          body[0].style.paddingBottom = '0px';
        }
      }
    }
  }
};